import * as Html from "../../util/Html.ts";
import * as rrule from "../../lib/rrule/rrule.js";
import { dateAdd, dateSet, forInputDate, format } from "../../lib/DateUtils.ts";
import * as CustomInput from "../../util/CustomInput.ts";

export {initDom}
Html.registerWidget('widget/form/recurrencyend',{initDom})

function rruleBuilderPublic(rec,interval,byday,date){
  if(rec==="BIWEEKLY"){
    return new rrule.RRule({
      freq: rrule.RRule.WEEKLY,
      interval:2,
      dtstart : date
    })
  }else if(rec==="DAYWEEK" || rec==="WEEKLY|1|MO,TU,WE,TH,FR"){
    return new rrule.RRule({
      freq: rrule.RRule.WEEKLY,
      byweekday: [rrule.RRule.MO,rrule.RRule.TH,rrule.RRule.WE,rrule.RRule.TU, rrule.RRule.FR],
      interval:interval,
      dtstart : date
    })
  }
  var options = {
    freq: rrule.RRule[rec],
    //byweekday:rec==='WEEKLY'?byday.map(key=>rrule.RRule[key]):undefined,
    interval:interval,
    dtstart : date,
    byweekday : undefined
  }
  if(rec==='WEEKLY' && byday.length>0){
    options.byweekday = byday.map(key=>rrule.RRule[key]);
  }else if(rec==='MONTHLY'){
    //options.bymonthday = byday;
  }
  return new rrule.RRule(options)
}
function initDom(obj: HTMLElement){
  const form = obj.closest('form') as HTMLFormElement;
  const recurrencyInput = form.querySelector('[name="recurrency"]') as HTMLInputElement;
  const intervalInput = form.querySelector('[name="recurrencyInterval"]') as HTMLInputElement;
  const byDayInput = form.querySelector('[name="byDay"]') as HTMLInputElement;
  const startInput = form.querySelector('[name="startDate"], [name="dueDate"]') as HTMLInputElement;
  const placeholder = obj.querySelector(".recurrency-end-placeholder") as HTMLElement;
  const options = obj.querySelectorAll<HTMLElement>(".fw-option");
  const never = options[0];
  const ondate = options[1];
  const onOcc = options[2];
  const onOccInput = onOcc.querySelector('input');
  const ondateinput = ondate.querySelector('input');
  const input = obj.querySelector('input');

  function rruleBuilder(){
    const rec = recurrencyInput.value;
    const interval = Number(intervalInput.value);
    const byday = byDayInput.value.split(/,/g).filter(t=>t!=='');
    const date = CustomInput.getDateValue(startInput);

    return rruleBuilderPublic(rec, interval, byday, date!)
  }


  function refresh(){
    if(input.value === ''){
      input.value = '$empty';
    }
    if(input.value === '$empty'){
      placeholder.innerHTML = never.getAttribute("placeholder") || '';
    }else{
      const dateValue = CustomInput.getDateValue(input);
      placeholder.innerHTML = (ondate.getAttribute("placeholder") || '') + format(dateValue!, 'L');
    }
  }
  function setDateFromInput(): Date | null {
    const dateValue = CustomInput.getDateValue(ondateinput);
    if(dateValue){
      const date = dateSet(dateValue, {hour:23,minute:59,second:59,milli:0});
      CustomInput.setDateValue(input, date);
      return date;
    }else{
      input.value = "$empty";
      return null;
    }
  }

  function close(evt: MouseEvent){
    evt.stopPropagation();
    setDateFromInput();
    refresh();
    obj.classList.remove('fw-open');
    document.removeEventListener("mousedown", close);
  }
  function open(evt: MouseEvent){
    evt.stopPropagation();
    const rec = recurrencyInput.value;
    if(rec === 'NONE') return;
    const value = input.value;
    ondateinput.setAttribute('min', startInput.value.substring(0,10));
    if(value === '$empty'){
      ondateinput.value = '';
      ondateinput.dispatchEvent(new Event('change'));
      if(onOccInput.value){
        onOccInput.dispatchEvent(new Event('change'));
      }
    }else{
      ondateinput.value = forInputDate(new Date(input.value));
      ondateinput.dispatchEvent(new Event('change'));
    }

    obj.classList.add('fw-open');
    document.addEventListener("mousedown", close);
  }

  obj.addEventListener("mousedown", function(evt: MouseEvent){
    evt.stopPropagation();
  });

  obj.addEventListener("click", function(evt: MouseEvent){
    evt.stopPropagation();
    if(obj.classList.contains('fw-open')){
      close(evt);
    }else{
      open(evt);
    }
  });

  never.addEventListener("click", function(evt: MouseEvent){
    ondateinput.value = '';
    close(evt);
  });

  ondate.addEventListener("click", function(evt: MouseEvent){
    evt.stopPropagation();
    ondateinput.focus();
  });

  onOcc.addEventListener("click", function(evt: MouseEvent){
    evt.stopPropagation();
    onOccInput.focus();
  });


  //update fields against each other
  const handleOccInputChange = function(this: HTMLInputElement){
    let val = Number(this.value || 1);
    const max = Number(this.max);
    const min = Number(this.min);
    if(val > max){
      this.value = String(max);
    }else if(val < min){
      this.value = String(min);
    }

    const onOccValue = Number(this.value) - 1;

    if(!this.value || !startInput.value){
      return;
    }

    const ruleSet = new rrule.RRuleSet();
    ruleSet.rrule(rruleBuilder());

    let LIMIT = 20000;
    ruleSet.all(function(date: Date, idx: number){
      if(LIMIT--<=0){throw new Error("infinite loop")}
      if(idx>=onOccValue){
        ondateinput.value = date.toISOString().substring(0,10);
        return false;
      }else{
        return true;
      }
    })
  };

  onOccInput.addEventListener("change", handleOccInputChange);
  onOccInput.addEventListener("click", handleOccInputChange);

  const handleDateInputChange = function(this: HTMLInputElement){
    if(!this.value || !startInput.value){
      return;
    }
    const ruleSet = new rrule.RRuleSet();
    ruleSet.rrule(rruleBuilder());

    let LIMIT = 20000;
    const onDateValue = setDateFromInput();
    ruleSet.all(function(date: Date, idx: number){
      if(LIMIT--<=0){throw new Error("infinite loop")}
      if(date >= onDateValue!){
        onOccInput.value = String(idx);
        return false;
      }else{
        return true;
      }
    })
  };

  ondateinput.addEventListener("change", handleDateInputChange);
  ondateinput.addEventListener("click", handleDateInputChange);

  refresh();
}